export default __webpack_public_path__ + "static/media/quote-icon.480f3392.jpeg";